// extracted by mini-css-extract-plugin
export default {"container":"kL-z","error":"lL-z","disabled":"mL-z","submit":"nL-z","option":"oL-z","success":"pL-z","failure":"qL-z"};